import { createFileRoute } from '@tanstack/react-router'
import { LoadNewPage } from '@/features/loads/load-new-page'

export const Route = createFileRoute('/_authenticated/loads/new')({
  component: LoadNewPage,
})
